'use client'

import { useEffect, useState } from 'react'

import { useParams } from 'next/navigation'

import { dictionaryService } from './dictionaryService'

const useDictionary = (): Localication | null => {
    const [dictionary, setDictionary] = useState<Localication | null>(null)
    const params = useParams()

    useEffect(() => {
        const fetchDictionary = async () => {
            try {
                const result = await dictionaryService.getDictionary(params.lang as string)
                setDictionary(result)
            } catch (error) {
                console.error(error)
            }
        }

        fetchDictionary()
    }, [params.lang])

    return dictionary
}

export default useDictionary
